import { render, staticRenderFns } from "./lazy-load-list.vue?vue&type=template&id=ca75defe&scoped=true"
import script from "./lazy-load-list.vue?vue&type=script&lang=js"
export * from "./lazy-load-list.vue?vue&type=script&lang=js"
import style0 from "./lazy-load-list.vue?vue&type=style&index=0&id=ca75defe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca75defe",
  null
  
)

export default component.exports